import { Utils } from './utils';
/**
 * Default, and essentially ONLY, property comparer for equalitycheck
 * @param old value 1
 * @param val value 2
 */
export const DefaultComparer = (old, val) => Utils.areSemanticallyEqual(old, val);
//}
